import { render, staticRenderFns } from "./HaberDetay.vue?vue&type=template&id=12942a52&scoped=true&"
import script from "./HaberDetay.vue?vue&type=script&lang=js&"
export * from "./HaberDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12942a52",
  null
  
)

export default component.exports